import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * TabLoader
 * 
 * Loading component used as Suspense fallback when lazily loading tab components
 */
const TabLoader = () => (
  <div className="flex justify-center items-center p-8">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
  </div>
);

export default TabLoader; 